import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function QuoteSummaryTextColumn(props: UseTableCellProps<CustomerContractInventoryGridItem>) {
  const { value } = props;

  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{value}</Typography>
    </Box>
  );
}
